(function(angular){
	'use strict';
	
	var historicalGrowthOfInvestmentChartObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			reitName: '@'
		},
		controller: [
			'$filter',
			'urlFactory',
			HistoricalGrowthOfInvestmentChartFunction
		],
		controllerAs: 'historicalGrowthOfInvestmentChart'
	};
	
	angular
		.module('productPage')
		.component('historicalGrowthOfInvestmentChart', historicalGrowthOfInvestmentChartObject);
	
	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/reits/product-pages/historical-growth-of-investment-chart.html';
	}
	
	function HistoricalGrowthOfInvestmentChartFunction(
		$filter,
		urlFactory){
		var historicalGrowthOfInvestmentChart = this;

		historicalGrowthOfInvestmentChart.$onInit = function() {
			urlFactory.getPromise('/hypothetical-investment-over-time.json?reitOfferingUrlSlug=' + historicalGrowthOfInvestmentChart.reitName)
				.then(
					function(response) {
						initChart(response.data);
					}
				);
		};

		function initChart(responseData){
			var data = [];

			angular.forEach(responseData, function(entry) {
				data.push(entry.totalValue);
			});


			historicalGrowthOfInvestmentChart.chartOptions = {
				chart: {
					type: 'area'
				},
				series: [{
					data: data,
					pointInterval: 24 * 3600 * 1000,
					pointStart: responseData[0].chartDate,
					states: {
						hover: {
							enabled: true
						}
					}
				}],
				tooltip: {
					enabled: true,
					crosshairs: true,
					formatter: function() {
						return '<span class="eta display-block body-text-color text-align-center">' + $filter('date')(this.x, 'MMM d, yyyy') + '</span><span class="zeta display-block heading-text-color font-weight-bold text-align-center">' + $filter('currency')(this.y, '$', 2) + '</span>';
					}
				},
				xAxis: {
					type: 'datetime',
					tickInterval: 24 * 3600 * 1000 * 30 * 3
				},
				yAxis: {
					labels: {
						formatter: function() {
							return $filter('currency')(this.value, '$', 0);
						}
					},
					maxPadding: 0,
					min: 9000,
					tickInterval: 1000
				}
			};
		}
	}
})(window.angular);